import { render, staticRenderFns } from "./Stadiums.vue?vue&type=template&id=442d8f72&"
import script from "./Stadiums.vue?vue&type=script&lang=js&"
export * from "./Stadiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports